export default "__VITE_ASSET__ClPy8smv__"